import request from '../request';

// 获取班级列表
export const getClassList = (query) => {
  return request({
    url: '/api/user_manage/manageClass/queryClass',
    method: 'post',
    data: query,
  });
};

// 获取班级信息（批量）
export const getClassBatch = (query) => {
  return request({
    url: '/api/user_manage/manageClass/queryClassBatch',
    method: 'post',
    data: query,
  });
};

// 查询班级成员
export const getClassUser = (query) => {
  return request({
    url: '/api/user_manage/manageClass/queryAllClassUser',
    method: 'post',
    data: query,
  });
};

// 批量新增班级用户
export const addClassUserBatch = (query) => {
  return request({
    url: '/api/user_manage/manageClass/addClassUserBatch',
    method: 'post',
    data: query,
  });
};

// 批量删除班级用户
export const delClassUserBatch = (query) => {
  return request({
    url: '/api/user_manage/manageClass/delClassUserBatch',
    method: 'post',
    data: query,
  });
};

// 校验教师
export const checkTeacher = (query) => {
  return request({
    url: '/api/user_manage/manageClass/checkTeacher',
    method: 'post',
    data: query,
  });
};

// 查询年级
export const queryGrade = (query) => {
  return request({
    url: '/api/user_manage/class/queryGrade',
    method: 'post',
    data: query,
  });
};

// 新增班级
export const createClass = (query) => {
  return request({
    url: '/api/user_manage/manageClass/createClass',
    method: 'post',
    data: query,
  });
};

// 新增家长同步班级
export const createParentSyncClass = (query) => {
  return request({
    url: '/api/user_manage/manageClass/createParentSyncClass',
    method: 'post',
    data: query,
  });
};
